<!--
Copyright by:

by ESS-Ehrhardt Software Solutions & Service GmbH
Basselscheider Str. 55
D-56281 Emmelshausen
+49 (0) 67 42 / 87 27 0
info@epg.com
-->
<mat-selection-list
  [multiple]="false"
  hideSingleSelectionIndicator
  (selectionChange)="selectionChanged($event)"
>
  <mat-list-option value="elearning">
    <span i18n="@@sideSubMenuELearning">e-Learning</span>
    <fa-icon class="icon" [icon]="faArrowUpRightFromSquare"></fa-icon>
  </mat-list-option>
</mat-selection-list>
